import type { IPageService } from "./IPageService";

export const addLoading = <T>(pageService: IPageService) => pageService.addLoading<T>();
